<template>
    <div
        :style="{borderBottom: borderBottom}"
        class="nch--content-icons d-flex align-items-center justify-content-center pt-3"
    >
        <div class="content-flag mx-3" v-if="count.hasOwnProperty('courses') && count.courses > 0">
            <span>
                <i class="ni-3x" :class="contentIcon('Details-Course')"></i>
            </span>
            <p class="mb-0 text-center">{{count.courses}} {{count.courses === 1 ? $t('common.course'): $t('common.courses')}}</p>
        </div>
        <div class="content-flag mx-3" v-if="count.hasOwnProperty('modules') && count.modules > 0">
            <span>
                <i class="ni-3x" :class="contentIcon('Details-Module')"></i>
            </span>
            <p class="mb-0 text-center">{{count.modules}} {{count.modules === 1 ? $t('common.module'): $t('common.modules')}}</p>
        </div>
        <div class="content-flag mx-3" v-if="count.hasOwnProperty('lessons') && count.lessons > 0 ">
            <span>
                <i class="ni-3x" :class="contentIcon('Details-Lesson')"></i>
            </span>
            <p class="mb-0 text-center">{{count.lessons}} {{count.lessons === 1 ? $t('common.lesson'): $t('common.lessons')}}</p>
        </div>
        <div class="content-flag mx-3" v-if="count.hasOwnProperty('exercises') && count.exercises > 0">
            <span>
                <i class="ni-3x" :class="contentIcon('Details-Exercise')"></i>
            </span>
            <p class="mb-0 text-center">{{count.exercises}} {{count.exercises === 1 ? $t('common.exercise'): $t('common.exercises')}}</p>
        </div>
    </div>
</template>

<script>

import ContentIcons from "../../mixins/ContentIcon";

export default {
    name: "PlanDetailsIcons",
    props: {
        count: {
            type: Object,
            required: true
        }
    },
    mixins: [
        ContentIcons,
    ],
    methods: {},
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        borderBottom() {
            return `4px solid ${this.color.primary}`;
        }
    }
};
</script>

<style scoped>
.content-flag {
    flex-flow: column;
    align-content: center;
    align-items: center;
    display: flex;
    justify-items: center;
}
</style>
